import React from "react";
import InfoModal from "./InfoModal";
import RiskModal from "./RiskModal";
import UpdateRiskScoreModal from "./UpdateRiskScoreModal";
import ReviewRiskModal from "./ReviewRiskModal";
import MeasureModal from "../measures/MeasureModal";
import UpgradeModal from "./UpgradeModal";
import SoaImplementedModal from "./SoaImplementedModal";
import ArchiveRiskModal from "./ArchiveRiskModal";
import { MODAL_TYPES } from "./modalTypes";

// Re-export for convenience
export { MODAL_TYPES };

function ModalManager({ modalState, setRefreshData }) {
  const { type, show, ...modalProps } = modalState;

  if (!show || !type) {
    return null;
  }

  const renderModal = () => {
    switch (type) {
      case MODAL_TYPES.INFO:
        return (
          <InfoModal 
            state={modalState} 
          />
        );
      
      case MODAL_TYPES.RISK:
        return (
          <RiskModal 
            show={show}
            riskObj={modalProps.riskObj}
            setRefreshData={setRefreshData}
            resumeFromIndex={modalProps.resumeFromIndex}
            resumePreviousOwners={modalProps.resumePreviousOwners}
          />
        );
      
      case MODAL_TYPES.UPDATE_RISK_SCORE:
        return (
          <UpdateRiskScoreModal 
            show={show}
            riskObj={modalProps.riskObj}
            setRefreshData={setRefreshData}
            updateReason={modalProps.updateReason}
          />
        );
      
      case MODAL_TYPES.REVIEW_RISK:
        return (
          <ReviewRiskModal 
            show={show}
            riskObj={modalProps.riskObj}
            setRefreshData={setRefreshData}
          />
        );
      
      case MODAL_TYPES.MEASURE:
        return (
          <MeasureModal 
            show={show}
            measureObj={modalProps.measureObj}
            handleClose={modalProps.handleClose}
            uniqueOwners={modalProps.uniqueOwners}
          />
        );

      case MODAL_TYPES.UPGRADE:
        return (
          <UpgradeModal 
            isOpen={show}
            featureType={modalProps.featureType}
            currentLimit={modalProps.currentLimit}
            currentCount={modalProps.currentCount}
            recommendedPlan={modalProps.recommendedPlan}
          />
        );

      case MODAL_TYPES.SOA_IMPLEMENTED:
        return (
          <SoaImplementedModal
            isOpen={show}
            category={modalProps.category}
            categoryLabel={modalProps.categoryLabel}
            measureCount={modalProps.measureCount}
            onConfirm={modalProps.onConfirm}
          />
        );
      
      case MODAL_TYPES.ARCHIVE_RISK:
        return (
          <ArchiveRiskModal
            show={show}
            riskObj={modalProps.riskObj}
            setRefreshData={setRefreshData}
            onArchived={modalProps.onArchived}
            silent={modalProps.silent}
          />
        );

      default:
        return null;
    }
  };

  return renderModal();
}

export default ModalManager;
